<template>
  <div class="main-container">
    <div class="main-container-title-box">
      <div class="main-container-title-box-text">
        <span class="title-box-text"> Письма </span>
      </div>
    </div>

    <div v-show="!loading">
      <div class="table-container">
        <v-data-table
          :headers="tableHeaders"
          :items="mailItems"
          :footer-props="{
            itemsPerPageOptions: [10, 25, 50],
            'items-per-page-text': '',
          }"
          class="elevation-0 main-table"
          :items-per-page="optionTable.itemsPerPage"
          :page="optionTable.page"
          :server-items-length="optionTable.serverItemsLength"
          @pagination="tableChange"
          ref="sortableTable"
          fixed-header
        >
          <template v-slot:body="props">
            <tbody>
              <tr v-for="(item, index) in props.items" :key="index">
                <td>{{ item.id }}</td>
                <td>
                  {{ item.title }}
                </td>
                <td>
                  {{ item.description }}
                </td>
                <td>
                  {{ item.contentType }}
                </td>
                <td>
                  <template v-if="item.items">
                    {{ item.items.sentCount }}
                  </template>
                </td>
                <td>
                  <template v-if="item.items">
                    {{ item.items.notSentCount }}
                  </template>
                </td>
                <td>
                  <template v-if="item.items">
                    {{ item.items.totalCount }}
                  </template>
                </td>
                <td>
                  <template v-if="item.items">
                    {{
                      Math.floor(
                        (item.items.sentCount / item.items.totalCount) * 100
                      )
                    }}
                  </template>
                </td>
                <td>
                  {{ item.contentId }}
                </td>
                <td>
                  <span v-if="item.isSend"> Да</span>
                  <span v-else>Нет</span>
                </td>
                <td>
                  {{ item.dateCreated | moment(" HH:mm DD.MM.YYYY ") }}
                </td>
                <td>
                  <v-icon @click="deleteMail(item.id)" color="var(--app-red-1)"
                    >mdi-delete-outline</v-icon
                  >
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </div>
    </div>
    <div v-show="loading" class="body-container-mail">
      <v-progress-circular
        indeterminate
        :width="4"
        :size="70"
        color="var(--app-dark-blue-1) "
      ></v-progress-circular>
    </div>
    <v-divider></v-divider>
  </div>
</template>
<script>
export default {
  data: () => ({
    showInfo: false,
    x: null,
    y: null,
    mailItems: [],
    search: "",
    loading: true,
    optionTable: {
      page: 1,
      itemsPerPage: 10,
      serverItemsLength: -1,
    },

    tableHeaders: [
      {
        text: "ID",
        sortable: false,
      },
      {
        text: "Заголовок",
        sortable: false,
      },
      {
        text: "Описание",
        sortable: false,
      },
      {
        text: "Тип mail",
        sortable: false,
      },
      {
        text: "Кол-во отправленных",
        sortable: false,
      },
      {
        text: "Кол-во не отправленных",
        sortable: false,
      },
      {
        text: "Общее кол-во",
        sortable: false,
      },
      {
        text: "Процент отправленных",
        sortable: false,
      },
      {
        text: "ID типа",
        sortable: false,
      },
      {
        text: "Отправленно",
        sortable: false,
      },
      {
        text: "Дата создания",
        sortable: false,
      },
      {
        text: "",
        sortable: false,
      },
    ],
  }),
  methods: {
    checkLocal() {
      const localOptionTable = JSON.parse(
        localStorage.getItem("mailOptionTable")
      );
      if (localOptionTable) {
        this.optionTable = localOptionTable;
      }
    },
    deleteMail(id) {
      this.$axios
        .delete(this.$store.getters.apiAdminPanelV2 + "/mail", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
          },
          params: {
            mailId: id,
          },
        })
        .then(() => {
          this.getMail();
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    getMail() {
        this.loading = true;
        this.$axios
          .post(
            this.$store.getters.apiNotifications + "/email/list",
            {
              ...this.optionTable,
            },
            {
              headers: {
                "secret-key": this.$store.state.secretKeyCookie,
              },
            }
          )
          .then((res) => {
            this.optionTable = res.data.optionTable;
            this.mailItems = res.data.items;
            this.loading = false;
          })
          .catch((err) => {
            this.$store.commit("errorSet", true);
            this.$store.commit("errorTextSet", err);
          });
    },
    tableChange(data) {
      this.optionTable.page = data.page;
      this.optionTable.itemsPerPage = data.itemsPerPage;
      localStorage.setItem("mailOptionTable", JSON.stringify(this.optionTable));
      this.getMail();
    },
  },
  created() {
    this.checkLocal();
    this.getMail();
  },
};
</script>
<style lang="scss" scoped>
.body-container-mail {
  height: calc(100vh - 195px);
  display: flex;
  align-items: center;
  justify-content: center;
}
.table-container {
  height: calc(100vh - 195px);

  .main-table {
    height: calc(100vh - 195px) !important;
    min-height: calc(100vh - 195px) !important;
    max-height: calc(100vh - 195px) !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}
::v-deep .v-data-footer {
  margin-right: 0 !important;
}
</style>
